import { render } from "./RelatedOthers.vue?vue&type=template&id=71fe6d6e"
import script from "./RelatedOthers.vue?vue&type=script&lang=js"
export * from "./RelatedOthers.vue?vue&type=script&lang=js"

import "./RelatedOthers.vue?vue&type=style&index=0&id=71fe6d6e&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__